export default {
  funcionality: {
    label: 'analytics.details.funcionality',
    type: 'general',
    field: 'funcionality',
    align: 'left',
    customWidth: 220,
    render: true,
    fixed: false,
    order: 1

  },

}
